import useBottomSheet from 'hooks/common/useBottomSheet';

export type DeleteMessageData = {
  showDeleteEveryone: boolean;
};

const DeleteMessage: React.FC = () => {
  const { sheets, close } = useBottomSheet();
  const sheet = sheets.DeleteMessage;
  const data = sheet.data as DeleteMessageData;
  const { showDeleteEveryone } = data;

  // 닫으면서 data로 action과 both를 전달해 ChatMsgActionBtn.showDeletePopup에서 사용
  const handleDelete = (both: boolean) => {
    close('DeleteMessage', {
      data: { action: 'delete', both },
    });
  };

  const handleCancel = () => {
    close('DeleteMessage');
  };

  return (
    <div className="flex h-full w-full flex-col items-center gap-[var(--spacing-2xl)]">
      <div className="typography-headline-md text-dialog-txt-default">{brsc.ask_delete}</div>
      <div className="flex w-full flex-col gap-[var(--spacing-sm)]">
        {showDeleteEveryone && (
          <button
            onClick={() => handleDelete(true)}
            className="typography-headline-lg flex h-12 items-center justify-center rounded-md border-solid border-btn-border-normal bg-transparent p-[var(--spacing-md)] text-base-txt-primary"
          >
            {brsc.chat_delete_everyone}
          </button>
        )}
        <button
          onClick={() => handleDelete(false)}
          className="typography-headline-lg flex h-12 items-center justify-center rounded-md border-solid border-btn-border-normal bg-transparent p-[var(--spacing-md)] text-base-txt-primary"
        >
          {brsc.chat_delete_me}
        </button>
        <button
          onClick={() => handleCancel()}
          className="typography-headline-lg flex h-14 items-center justify-center rounded-lg border-none bg-btn-bg-normal p-[var(--spacing-lg)] text-btn-txt-normal"
        >
          {brsc.cancel}
        </button>
      </div>
    </div>
  );
};

export default DeleteMessage;
